"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateDictType = exports.deleteDictTypeById = exports.deleteBatchDictTypeById = exports.addDictType = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
/**
 * 添加字典类型表
 * @param dictType
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var addDictType = exports.addDictType = function addDictType(dictType) {
  return _api.default.request({
    url: '/system/dict-type/save',
    method: 'post',
    data: dictType
  });
};

/**
 * 修改字典类型表
 * @param dictType
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var updateDictType = exports.updateDictType = function updateDictType(dictType) {
  return _api.default.request({
    url: '/system/dict-type/update',
    method: 'post',
    data: dictType
  });
};

/**
 * 删除字典类型表
 * @param id
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var deleteDictTypeById = exports.deleteDictTypeById = function deleteDictTypeById(id) {
  return _api.default.request({
    url: '/system/dict-type/delete',
    method: 'post',
    params: {
      id: id
    }
  });
};

/**
 * 批量删除字典类型表
 * @param ids
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var deleteBatchDictTypeById = exports.deleteBatchDictTypeById = function deleteBatchDictTypeById(ids) {
  return _api.default.request({
    url: '/system/dict-type/deleteBatch',
    method: 'post',
    data: ids
  });
};